import * as types from '../const/action.types';

export function onboarding(state = {}, action) {
    switch (action.type) {
        case types.LOAD_ONBOARDING_SUCCESS:
            console.log(action.data);
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function onboardingHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.ONBOARDING_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function onboardingIsLoading(state = false, action) {
    switch (action.type) {
        case types.ONBOARDING_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function onboarding_permission(state = [], action) {
    switch (action.type) {
        case types.ONBOARDING_PERMISSIONS_SUCCESS:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/onboarding.reducer.js